import { gql } from "@apollo/client";

const REMOVE_REGISTERED_INSTITUTION = gql`
  mutation removeRegisteredInstitution($id: ID!) {
    removeRegisteredInstitution(id: $id)
  }
`;

export default REMOVE_REGISTERED_INSTITUTION;
